import { render } from "./ClusterMaster.vue?vue&type=template&id=b4154284&scoped=true"
import script from "./ClusterMaster.vue?vue&type=script&lang=js"
export * from "./ClusterMaster.vue?vue&type=script&lang=js"

import "./ClusterMaster.vue?vue&type=style&index=0&id=b4154284&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4154284"]])

export default __exports__